import React from "react";
import { Card, CardContent, Stack, Box, Typography } from "@mui/material";

export default function RischioScoreCard({
  cardSx,
  contentSx,
  riskData = null,
  // Fallback values if riskData is not provided
  rischioScore = 35,
  rischioColor = "#6dc797",
  rischioDescrizione = "Rischio Basso",
  rischioTesto = "Azienda solida con profilo di rischio basso. Verificare completezza coperture.",
}) {
  // Use riskData if available, otherwise use fallback props
  const score = riskData?.score ?? rischioScore;
  const color = riskData?.color ?? rischioColor;
  const description = riskData?.description ?? rischioDescrizione;
  const text = riskData?.text ?? rischioTesto;

  return (
    <Card
      sx={{
        ...cardSx,
        borderBottom: `5px solid ${color}`,
        display: "flex",
      }}
    >
      <CardContent
        sx={{
          ...contentSx,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Stack alignItems="center" spacing={2} sx={{ width: "100%" }}>
          <Box
            sx={{
              width: 112,
              height: 112,
              borderRadius: "50%",
              border: `7px solid ${color}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography sx={{ fontWeight: 900, fontSize: 44, lineHeight: 1 }}>
              {score}
            </Typography>
          </Box>

          <Typography sx={{ fontWeight: 900, color: color, fontSize: 16, textAlign: "center" }}>
            {description}
          </Typography>

          <Typography
            variant="body2"
            textAlign="center"
            color="text.secondary"
            sx={{ fontSize: 13.5, width: "100%" }}
          >
            {text}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}